import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';

// True while the client has a live socket to the Realtime Database.
export default function useConnection() {
  const [connected, setConnected] = useState(true);
  useEffect(() => {
    const unsubscribe = onValue(ref(database, '.info/connected'), (snap) => {
      setConnected(snap.val() === true);
    });
    return unsubscribe;
  }, []);
  return connected;
}
